<nav class="top-navigation" data-test="topNavigation">
  <div class="top-navigation__container">
    <div>
      <a [routerLink]="backLinkPath" data-test="linkBackTopNavigation" class="top-navigation__back" *ngIf="hasBackLink" aria-label="Voltar para a tela anterior" (click)="eventEmitterBack()" >Voltar</a>
      <h1 class="top-navigation__title" data-test="titleTopNavigation">
        <ng-content select="[title]"></ng-content>
      </h1>
      <h4 class="top-navigation__subtitle" data-test="subtitleTopNavigation">
        <ng-content select="[subtitle]"></ng-content>
      </h4>
    </div>
    <div *ngIf="!hideButtons">
      <ng-content select="[links]"></ng-content>
    </div>
  </div>
  <ul *ngIf="hasStatusMenu && !hideButtons" class="top-navigation__menu" data-test="listStatus">
    <li><button aria-label="Colaboradores Ativos" [ngClass]="{'--active' : active === 'active'}" (click)="changeStatus('active')" data-test="btnActiveEmployees">Ativos</button></li>
    <li><button aria-label="Colaboradores Inativos" [ngClass]="{'--active' : active === 'inactive'}" (click)="changeStatus('inactive')" data-test="btnInactiveEmployees">Inativos</button></li>
  </ul>
</nav>
